module.exports = __webpack_public_path__ + "static/media/NYF.3fd8a6db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/NYF.png
// module id = 462
// module chunks = 0